import { Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { GeneralIconButtonComponent } from '../general-icon-button/general-icon-button.component';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-notification',
  imports: [MatIconModule, TranslatePipe, GeneralIconButtonComponent],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss',
})
export class NotificationComponent {
  public snackBarRef = inject(MatSnackBarRef<NotificationComponent>);
  public data = inject<{ type: 'error' | 'success'; message: string; icon: string }>(MAT_SNACK_BAR_DATA);

  close(): void {
    this.snackBarRef.dismiss();
  }
}
